import batyr from "./batyr.png";
import bullyzero from "./bullyzero.png";
import cantoo from "./cantoo.png";
import cci from "./cci.png";
import cef from "./cef.png";
import clontarf from "./clontarf.png";
import humpty from "./humpty.png";
import ruok from "./ruok.png";
import schf from "./schf.png";
import yo from "./yo.png";
import zephyr from "./zephyr.png";

const Logowall = () => {
  return (
    <div className="logowall">
      <span><img src={ruok} alt="RUOK" /></span>
      <span><img src={cef} alt="Country Education Foundation Australia" /></span>
      <span><img src={zephyr} alt="Zephyr" /></span>
      <span><img src={yo} alt="Youth Opportunities" /></span>
      <span><img src={cci} alt="Children's Cancer Institute" /></span>
      <span><img src={humpty} alt="Humpty Dumpty Foundation" /></span>
      <span><img src={batyr} alt="Batyr" /></span>
      <span><img src={schf} alt="Sydney Children's Hospitals Foundation" /></span>
      <span><img src={clontarf} alt="Clontarf Foundation" /></span>
      <span><img src={cantoo} alt="CanToo" /></span>
      <span><img src={bullyzero} alt="Bully Zero" /></span>
    </div>
  );
}

export default Logowall;